<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0"></h6>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="card mb-4">
                <div class="card-header mt--4">
                    <div class="row">
                        <div class="col">
                            <h3 class="mb-0">{{ tt('detail_import_data') }}</h3>
                        </div>
                        <div class="text-right mr-3">
                            <base-button size="sm" type="primary" @click="sendToSAP" :disabled="selectedRows.length === 0 || loadingBtnSendSAP" v-if="activeTab == 'Ready to SAP'">
                                <span v-if="loadingBtnSendSAP"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                                <span v-else>{{ tt('send_to_sap') }}</span>
                            </base-button>
                            <base-button size="sm" type="warning" @click="exportFailed" :disabled="loadingBtnExport" v-if="activeTab === 'Failed' && table.length > 0">
                                <span v-if="loadingBtnExport"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                                <span v-else><i class="fas fa-file-excel"></i> Export</span>
                            </base-button>
                            <base-button size="sm" type="success" @click="activeTab === 'Success' ? getReleasedData() : get()">
                                <i class="fas fa-sync-alt"></i>
                            </base-button>
                            <base-button size="sm" type="danger" @click="goBack">{{ tt('back') }}</base-button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row no-gutters justify-content-center mb-4">
                        <div class="col">
                            <button class="btn-sm btn m-0 w-100 rounded-0 p-2"
                            :class="activeTab == 'Ready to SAP' ? 'btn-darks' : 'btn-light'" @click="switchTab('Ready to SAP')" :disabled="onLoad">
                            Ready to SAP</button>
                        </div>
                        <div class="col">
                            <button class="btn-sm btn m-0 w-100 rounded-0 p-2"
                            :class="activeTab == 'Success' ? 'btn-darks' : 'btn-light'" @click="switchTab('Success')" :disabled="onLoad">
                            Success Upload to SAP</button>
                        </div>
                        <div class="col">
                            <button class="btn-sm w-100 btn-rounded-non btn p-2"
                            :class="activeTab == 'Failed' ? 'btn-darks' : 'btn-light'" @click="switchTab('Failed')" :disabled="onLoad">
                            Failed Import to TOMS</button>
                        </div>
                    </div>

                     <div v-if="activeTab == 'Success'">
                        <div>
                            <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table" v-if="!onLoad" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
                                <el-table-column :label="tt('material_number')" min-width="200px" sortable>
                                    <template v-slot="{row}">
                                        {{row.material_number}}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('po_text_toms')" min-width="550px">
                                    <template v-slot="{row}">
                                        <template v-if="getSnapShoot(row, 'po_text_toms')">
                                            <div class="border mb-3">
                                                <div class="p-3">
                                                    <span style='font-size: 12px'>{{ getSnapShoot(row, 'po_text_toms').short_description }}</span>
                                                </div>
                                            </div>
                                            <div class="border">
                                                <div class="p-3">
                                                    <h5 v-if="getSnapShoot(row, 'po_text_toms').inc_name">{{ getSnapShoot(row, 'po_text_toms').inc_name }}</h5>
                                                    <div class='row' v-for="(cv, keyRow) in getSnapShoot(row, 'po_text_toms').char_values" :key="'toms-char-' + keyRow">
                                                        <span class='col-6' style='font-size: 12px'>{{cv.characteristic}}</span>
                                                        <span class='col-6' style='font-size: 12px'>: {{cv.characteristic_value}}</span>
                                                    </div>
                                                    <div class="mt-4" v-if="getSnapShoot(row, 'po_text_toms').po_text_memo">
                                                        <h5 class="text-uppercase">{{ tt('po_text_memo') }}</h5>
                                                        <span style='font-size: 12px'>{{ getSnapShoot(row, 'po_text_toms').po_text_memo }}</span>
                                                    </div>
                                                    <h5 class="mt-4 text-uppercase" v-if="getSnapShoot(row, 'po_text_toms').equipment && getSnapShoot(row, 'po_text_toms').equipment.length">{{ tt('equipment') }}</h5>
                                                    <div class='row mb-3' v-for="(equipment, equipIdx) in getSnapShoot(row, 'po_text_toms').equipment" :key="'toms-equip-' + equipIdx" v-if="equipment.show">
                                                        <span class="col-12" style='font-size: 12px'>S/P FOR {{ equipment.equipment_code.join(', ') }}</span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">EQUIPMENT NAME</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">: {{ equipment.equipment_name }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.type">TYPE</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.type">: {{ equipment.type }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">SERIAL NUMBER</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">: {{ equipment.serial_number }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">MANUFACTURER</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">: {{ equipment.manufacturer }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">ADDITIONAL DATA</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">: {{ equipment.additional_data }}</span>
                                                        </span></span>
                                                    </div>
                                                    <h5 class="mt-4 text-uppercase" v-if="getSnapShoot(row, 'po_text_toms').manufacture_refs && getSnapShoot(row, 'po_text_toms').manufacture_refs.length">{{ tt('manufacturer_reference') }}</h5>
                                                    <div class='row' v-for="(mpn, key) in getSnapShoot(row, 'po_text_toms').manufacture_refs" :key="'toms-mpn-' + key">
                                                        <span class='col-6' style='font-size: 12px'>{{mpn.manufacture_name}}</span>
                                                        <span class='col-6' style='font-size: 12px'>: {{mpn.source_type_code +':'+ mpn.manufacture_ref}} <span v-if="mpn.position">POS:{{ mpn.position }}</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('latest_po_text_sap')" min-width="550px">
                                    <template v-slot="{row}">
                                        <template v-if="getSnapShoot(row, 'po_text_sap')">
                                            <div class="border mb-3">
                                                <div class="p-3">
                                                    <span style='font-size: 12px'>{{ getSnapShoot(row, 'po_text_sap').short_description }}</span>
                                                </div>
                                            </div>
                                            <div class="border">
                                                <div class="p-3">
                                                    <div v-for="(existingPOText, keyRow) in getSnapShoot(row, 'po_text_sap').po_text" :key="'sap-line-' + keyRow">
                                                        <h5 v-if="!existingPOText.val && keyRow == 0">{{ existingPOText?.key }}</h5>
                                                        <h5 class="mt-4" v-else-if="!existingPOText.val && keyRow != 0 && isKeyPOtext(existingPOText?.key)">{{ existingPOText?.key }}</h5>
                                                        <span v-else-if="!existingPOText.val && keyRow != 0" style='font-size: 12px'>{{existingPOText?.key}}</span>

                                                        <div class="mt-3"
                                                            v-if="!existingPOText.val && !existingPOText.key && (!isKeyPOtext(getSnapShoot(row, 'po_text_sap').po_text[keyRow + 1]?.key)) && keyRow != (getSnapShoot(row, 'po_text_sap').po_text.length - 1)"
                                                        ></div>

                                                        <div class="row" v-if="existingPOText.val">
                                                            <span class="col-6" style='font-size: 12px'>{{existingPOText?.key}}</span>
                                                            <span class="col-6" style='font-size: 12px'>: {{existingPOText?.val}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('new_po_text')" min-width="550px">
                                    <template v-slot="{row}">
                                        <template v-if="getSnapShoot(row, 'po_text_upload')">
                                            <div class="border mb-3">
                                                <div class="p-3">
                                                    <span style='font-size: 12px'>{{ getSnapShoot(row, 'po_text_upload').short_description }}</span>
                                                </div>
                                            </div>
                                            <div class="border">
                                                <div class="p-3">
                                                    <h5 v-if="getSnapShoot(row, 'po_text_upload').inc_name">{{ getSnapShoot(row, 'po_text_upload').inc_name }}</h5>
                                                    <div class='row' v-for="(cv, keyRow) in getSnapShoot(row, 'po_text_upload').char_values" :key="'upload-char-' + keyRow">
                                                        <span class='col-6' style='font-size: 12px'>{{cv.characteristic}}</span>
                                                        <span class='col-6' style='font-size: 12px'>: {{cv.characteristic_value}}</span>
                                                    </div>
                                                    <div class="mt-4" v-if="getSnapShoot(row, 'po_text_upload').po_text_memo">
                                                        <h5 class="text-uppercase">{{ tt('po_text_memo') }}</h5>
                                                        <span style='font-size: 12px'>{{ getSnapShoot(row, 'po_text_upload').po_text_memo }}</span>
                                                    </div>
                                                    <h5 class="mt-4 text-uppercase" v-if="getSnapShoot(row, 'po_text_upload').equipment && getSnapShoot(row, 'po_text_upload').equipment.length">{{ tt('equipment') }}</h5>
                                                    <div class='row mb-3' v-for="(equipment, equipIdx) in getSnapShoot(row, 'po_text_upload').equipment" :key="'upload-equip-' + equipIdx" v-if="equipment.show">
                                                        <span class="col-12" style='font-size: 12px'>S/P FOR {{ equipment.equipment_code.join(', ') }}</span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">EQUIPMENT NAME</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">: {{ equipment.equipment_name }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.type">TYPE</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.type">: {{ equipment.type }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">SERIAL NUMBER</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">: {{ equipment.serial_number }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">MANUFACTURER</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">: {{ equipment.manufacturer }}</span>
                                                        </span></span>
                                                        <span class="col-12"><span class="row">
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">ADDITIONAL DATA</span>
                                                            <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">: {{ equipment.additional_data }}</span>
                                                        </span></span>
                                                    </div>
                                                    <h5 class="mt-4 text-uppercase" v-if="getSnapShoot(row, 'po_text_upload').manufacture_refs && getSnapShoot(row, 'po_text_upload').manufacture_refs.length">{{ tt('manufacturer_reference') }}</h5>
                                                    <div class='row' v-for="(mpn, key) in getSnapShoot(row, 'po_text_upload').manufacture_refs" :key="'upload-mpn-' + key">
                                                        <span class='col-6' style='font-size: 12px'>{{mpn.manufacture_name}}</span>
                                                        <span class='col-6' style='font-size: 12px'>: {{mpn.source_type_code +':'+ mpn.manufacture_ref}} <span v-if="mpn.position">POS:{{ mpn.position }}</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('status')" min-width="152px" sortable>
                                    <template v-slot="{row}">
                                        <span class="badge badge-success" v-if="row.status === 'Success'">{{ row.status }}</span>
                                        <span class="badge badge-danger" v-else-if="row.status === 'Error'">{{ row.status }}</span>
                                        <span class="badge badge-primary" v-else>{{ row.status }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('harmonisasi_date')" min-width="188px" sortable header-align="center">
                                    <template v-slot="{row}">
                                        {{format_date(row.created_at)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="action" width="200">
                                    <template v-slot="{row}">
                                        <div class="btn-group mr-1">
                                            <button class="btn btn-sm" :class="rowFlags[row.mcr_item_code] === 1 ? 'btn-primary' : 'btn-outline-primary'" @click="toggleFlag(row.mcr_item_code, 1)">Before</button>
                                            <button class="btn btn-sm" :class="rowFlags[row.mcr_item_code] === 2 ? 'btn-primary' : 'btn-outline-primary'" @click="toggleFlag(row.mcr_item_code, 2)">After</button>
                                        </div>
                                        <base-button size="sm" type="dark" @click="syncTaskLog(row.mcr_code)">{{ tt('view_log') }}</base-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <skeleton-loading v-else/>
                        </div>
                        <div class="card-footer pb-0">
                            <span class="float-left">
                                <base-pagination :page-count="pagination.last_page" v-model="pagination.current_page" @click.native="handlePaginate(pagination.current_page)" size="sm"></base-pagination>
                            </span>
                            <span class="float-right">
                                {{ tt('page_info', {size: (pagination.current_page - 1) * pagination.per_page + table.length, total: pagination.total}) }}
                            </span>
                        </div>
                    </div>

                    <div v-if="activeTab == 'Ready to SAP'">
                        <div>
                            <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table" v-if="!onLoad" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
                        <el-table-column :label="tt('material_number')" :prop="tt('material_number')" min-width="200px" sortable>
                            <template v-slot="{row}">
                                {{row.material_number}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="tt('po_text_toms')" :prop="tt('po_text_toms')" min-width="550px" sortable>
                            <template v-slot="{row}">
                                <div class="border mb-3">
                                        <div class="p-3">
                                            <span style='font-size: 12px'>{{ row.part_master.short_description }}</span>
                                        </div>
                                    </div>
                                <div class="border">
                                    <div class="p-3">
                                        <h5 v-if="row.prc_inc_name">{{ row.part_master.prc_inc_name }}</h5>
                                        <div class='row' v-for="(row, keyRow) in row.part_master.char_values" :key="'char2-' + keyRow">
                                            <span class='col-6' style='font-size: 12px'>{{row.characteristic}}</span>
                                            <span class='col-6' style='font-size: 12px'>: {{row.characteristic_value}}</span>
                                        </div>

                                        <div class="mt-4" v-if="row.part_master.po_text_memo">
                                            <h5 class="text-uppercase">{{ tt('po_text_memo') }}</h5>
                                            <span style='font-size: 12px'>{{row.part_master.po_text_memo}}</span>
                                        </div>

                                        <h5 class="mt-4 text-uppercase" v-if="row.part_master.grouped_equipment.length">{{ tt('equipment') }}</h5>
                                        <div class='row mb-3' v-for="(equipment, equipIdx) in row.part_master.grouped_equipment" :key="'equip2-' + equipIdx" v-if="equipment.show">
                                            <span class="col-12" style='font-size: 12px'>S/P FOR {{ equipment.equipment_code.join(', ') }}</span>
                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">EQUIPMENT NAME</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">: {{ equipment.equipment_name }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.type">TYPE</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.type">: {{ equipment.type }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">SERIAL NUMBER</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">: {{ equipment.serial_number }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">MANUFACTURER</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">: {{ equipment.manufacturer }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">ADDITIONAL DATA</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">: {{ equipment.additional_data }}</span>
                                                </span>
                                            </span>
                                        </div>

                                        <h5 class="mt-4 text-uppercase" v-if="row.part_master.manufacture_refs.length">{{ tt('manufacturer_reference') }}</h5>
                                        <div class='row' v-for="(mpn, key) in row.part_master.manufacture_refs" :key="'mpn-' + key">
                                            <span class='col-6' style='font-size: 12px'>{{mpn.manufacture_name}}</span>
                                            <span class='col-6' style='font-size: 12px'>: {{mpn.source_type_code +':'+ mpn.manufacture_ref}} <span v-if="mpn.position">POS:{{ mpn.position }}</span></span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tt('latest_po_text_sap')" :prop="tt('material_number')" min-width="550" sortable>
                            <template v-slot="{row}">
                                <div>
                                    <div class="border mb-3">
                                        <div class="p-3">
                                            <span style='font-size: 12px'>{{ row.short_description_sap }}</span>
                                        </div>
                                    </div>
                                    <div class="border">
                                        <div class="p-3">
                                            <div v-for="(existingPOText, keyRow) in row.po_text_sap" :key="keyRow">
                                                <h5 v-if="!existingPOText.val && keyRow == 0">{{ existingPOText?.key }}</h5>
                                                <h5 class="mt-4" v-else-if="!existingPOText.val && keyRow != 0 && isKeyPOtext(existingPOText?.key)">{{ existingPOText?.key }}</h5>
                                                <span v-else-if="!existingPOText.val && keyRow != 0" style='font-size: 12px'>{{existingPOText?.key}}</span>

                                                <div class="mt-3" 
                                                    v-if="!existingPOText.val && !existingPOText.key && (!isKeyPOtext(row.po_text_sap[keyRow + 1]?.key)) && keyRow != (row.po_text_sap.length - 1)"
                                                ></div>

                                                <div class="row" v-if="existingPOText.val">
                                                    <span class="col-6" style='font-size: 12px'>{{existingPOText?.key}}</span>
                                                    <span class="col-6" style='font-size: 12px'>: {{existingPOText?.val}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tt('new_po_text')" :prop="tt('new_po_text')" min-width="550px" sortable>
                            <template v-slot="{row}">
                                <div class="border mb-3">
                                        <div class="p-3">
                                            <span style='font-size: 12px'>{{ row.short_description }}</span>
                                        </div>
                                    </div>
                                <div class="border">
                                    <div class="p-3">
                                        <h5 v-if="row.prc_inc_name">{{ row.prc_inc_name }}</h5>
                                        <div class='row' v-for="(row, keyRow) in row.prc_mcr_item_characteristic_value" :key="'char-' + keyRow">
                                            <span class='col-6' style='font-size: 12px'>{{row.characteristic}}</span>
                                            <span class='col-6' style='font-size: 12px'>: {{row.characteristic_value}}</span>
                                        </div>

                                        <div class="mt-4" v-if="row.prc_po_text_memo">
                                            <h5 class="text-uppercase">{{ tt('po_text_memo') }}</h5>
                                            <span style='font-size: 12px'>{{row.prc_po_text_memo}}</span>
                                        </div>

                                        <h5 class="mt-4 text-uppercase" v-if="row.grouped_equipment.length">{{ tt('equipment') }}</h5>
                                        <div class='row mb-3' v-for="(equipment, equipIdx) in row.grouped_equipment" :key="'equip-' + equipIdx" v-if="equipment.show">
                                            <span class="col-12" style='font-size: 12px'>S/P FOR {{ equipment.equipment_code.join(', ') }}</span>
                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">EQUIPMENT NAME</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.equipment_name">: {{ equipment.equipment_name }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.type">TYPE</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.type">: {{ equipment.type }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">SERIAL NUMBER</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.serial_number">: {{ equipment.serial_number }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">MANUFACTURER</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.manufacturer">: {{ equipment.manufacturer }}</span>
                                                </span>
                                            </span>

                                            <span class="col-12">
                                                <span class="row">
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">ADDITIONAL DATA</span>
                                                    <span class='col-6' style='font-size: 12px' v-if="equipment.additional_data">: {{ equipment.additional_data }}</span>
                                                </span>
                                            </span>
                                        </div>

                                        <h5 class="mt-4 text-uppercase" v-if="row.prc_mcr_manufacture.length">{{ tt('manufacturer_reference') }}</h5>
                                        <div class='row' v-for="(mpn, key) in row.prc_mcr_manufacture" :key="'mpn-' + key">
                                            <span class='col-6' style='font-size: 12px'>{{mpn.manufacture_name}}</span>
                                            <span class='col-6' style='font-size: 12px'>: {{mpn.source_type_code +':'+ mpn.manufacture_ref}} <span v-if="mpn.position">POS:{{ mpn.position }}</span></span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tt('latest_po_text_sap_date')" :prop="tt('latest_po_text_sap_date')" min-width="200px" sortable header-align="center">
                            <template v-slot="{row}">
                                {{format_date(row.latest_date)}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="tt('status')" :prop="tt('status')" min-width="152px" sortable>
                            <template v-slot="{row}">
                                <span class="badge badge-success" v-if="row.status === 'Success'">{{ row.status }}</span>
                                <span class="badge badge-danger" v-else-if="row.status === 'Error'">{{ row.status }}</span>
                                <span class="badge badge-primary" v-else>{{ row.status }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tt('harmonisasi_date')" :prop="tt('harmonisasi_date')" min-width="188px" sortable header-align="center">
                            <template v-slot="{row}">
                                {{format_date(row.created_at)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="action" width="120">
                            <template v-slot="{row}">
                                <base-button size="sm" type="primary" v-if="activeTab == 'Ready to SAP'" @click="$router.push('/material/mcr-form/'+row.form_type+'/'+row.mcr_code+'/'+row.mcr_item_code+'/'+row.token+'/edit')">{{ tt('review') }}</base-button>

                                <base-button  v-if="activeTab == 'Success'" size="sm" type="dark" @click="syncTaskLog(row.mcr_code)">{{ tt('view_log') }}</base-button>
                            </template>
                        </el-table-column>
                            </el-table>
                            <skeleton-loading v-else/>
                        </div>
                        <div class="card-footer pb-0">
                            <span class="float-left">
                                <base-pagination :page-count="pagination.last_page" v-model="pagination.current_page" @click.native="handlePaginate(pagination.current_page)" size="sm"></base-pagination>
                            </span>
                            <span class="float-right">
                            {{ tt('page_info', {size: (pagination.current_page - 1) * pagination.per_page + table.length, total: pagination.total}) }}
                            </span>
                        </div>
                    </div>

                    <div v-if="activeTab == 'Failed'">
                        <div>
                            <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table" v-if="!onLoad">
                                <el-table-column :label="tt('material_number')" :prop="tt('material_number')" min-width="200px" sortable>
                                    <template v-slot="{row}">
                                        {{row.material_number}}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('status')" :prop="tt('status')" min-width="170px" sortable>
                                    <template v-slot="{row}">
                                        <span class="badge badge-danger">{{ row.status }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('logs')" :prop="tt('logs')" min-width="300px" sortable>
                                    <template v-slot="{row}">
                                        <div v-for="(log, logIdx) in row.sap_import_log" :key="'log-' + logIdx">- {{ log.message }} ({{ log.key_import }})</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="tt('created_at')" :prop="tt('created_at')" min-width="171px" sortable>
                                    <template v-slot="{row}">
                                        {{format_date(row.created_at)}}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column prop="action" width="100">
                                    <template v-slot="{row}">
                                        <el-dropdown trigger="click" class="dropdown" :hide-on-click="true">
                                            <span class="btn btn-sm btn-icon-only text-light">
                                                <i class="fas fa-ellipsis-v mt-2"></i>
                                            </span>
                                            <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                                <router-link :to="'/material/mcr-form/'+row.form_type+'/'+row.mcr_code+'/'+row.mcr_item_code+'/'+row.token+'/edit'" class="dropdown-item ml-1" tag="button">{{ tt('edit') }}</router-link>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                            <skeleton-loading v-else/>
                        </div>
                        <div class="card-footer pb-0">
                            <span class="float-left">
                                <base-pagination :page-count="pagination.last_page" v-model="pagination.current_page" @click.native="handlePaginate(pagination.current_page)" size="sm"></base-pagination>
                            </span>
                            <span class="float-right">
                            {{ tt('page_info', {size: (pagination.current_page - 1) * pagination.per_page + table.length, total: pagination.total}) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <!-- SAP SYNC TASK LOG -->
        <modal :show.sync="sapSyncLogs.show" size="lg">
            <template slot="header">
                <h4 class="modal-title">{{ tt('synchron_task_log') }}</h4>
            </template>
            <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="sapSyncLogs.data" v-if="!sapSyncLogs.loading">
                <el-table-column :label="tt('sap_sync_task_id')" :prop="tt('sap_sync_task_id')" min-width="170px" sortable>
                    <template v-slot="{row}">
                        {{row.sap_sync_task_id}}
                    </template>
                </el-table-column>
                <el-table-column :label="tt('type')" :prop="tt('type')" min-width="170px" sortable>
                    <template v-slot="{row}">
                        {{row.type}}
                    </template>
                </el-table-column>
                <el-table-column :label="tt('message')" :prop="tt('message')" min-width="150px" sortable>
                    <template v-slot="{row}">
                        {{row.message}}
                    </template>
                </el-table-column>
                <el-table-column :label="tt('date')" :prop="tt('date')" min-width="190px" sortable>
                    <template v-slot="{row}">
                        {{row.timestamp}}
                    </template>
                </el-table-column>
            </el-table>
        </modal>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import SapImport from '@/services/report/sapimport.service.js';
    import sapSyncTask from '@/services/sap/sapSyncTask.service';
    import Swal from "sweetalert2";

    var moment = require('moment');

    export default {
        data() {
            return {
                moment: moment,
                onLoad: true,
                loadTimeout: null,
                sapImportCode: this.$route.params.code,
                token: localStorage.token,
                params: {
                    material_number: null,
                    subject:null,
                    created_at: null,
                    page: 1,
                    status: 'Ready to SAP',
                },
                table: [],
                pagination: {
                    current_page: 0,
                    last_page: 0,
                    per_page: 0,
                    total: 0,
                },
                selectedRows: [],
                loadingBtnSendSAP: false,
                loadingBtnExport: false,
                errorMessage: null,
                activeTab: 'Ready to SAP',
                rowFlags: {},
                sapSyncLogs: {
                    show: false,
                    loading: false,
                    data: []
                },
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
        },
        methods: {
            switchTab(value) {
                if (this.activeTab != value) {
                    this.activeTab = value
                    this.params.status = value
                    this.params.page = 1
                    this.table = []

                    if (value == 'Success') {
                        this.getReleasedData()
                    } else {
                        this.get()
                    }
                }
            },
            isKeyPOtext(key) {
                const poTextKeys = [
                    'PO TEXT MEMO',
                    'MANUFACTURE REFERENCE',
                    'EQUIPMENT'
                ];
                
                return poTextKeys.includes(key);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'task_log':
                            this.syncTaskLog(command.data.mcr_code);
                        break;
                    default:
                        break;
                }
            },
            syncTaskLog(mcr_code) {
                this.sapSyncLogs.show = true;
                this.sapSyncLogs.loading = true;
                console.log(mcr_code, 'mcr code')

                Api(this, sapSyncTask.task_log_by_mcr(mcr_code))
                    .onSuccess(response => {
                        console.log(response, 'response log');
                        this.sapSyncLogs.data = response.data.data;
                    })
                    .onFinish(() => {
                        this.sapSyncLogs.loading = false;
                    })
                    .onError(() => {
                        this.sapSyncLogs.data = [];
                    })
                    .call() 
            },
            getReleasedData() {
                this.onLoad = true
                 Api(this, SapImport.data_released(this.sapImportCode, this.params))
                    .onSuccess(response => {
                        const rawData = response.data.data.data.data || [];
                        this.table = rawData.map(item => {
                            const snaps = (item.snap_shoot_po_texts || []).map(snap => {
                                if (snap.po_text_sap && Array.isArray(snap.po_text_sap.po_text)) {
                                    const sectionHeadings = ['PO TEXT MEMO', 'MANUFACTURE REFERENCE', 'EQUIPMENT'];
                                    const processedPoText = [];
                                    snap.po_text_sap.po_text.forEach((poTextItem, idx) => {
                                        let valueSplitted = poTextItem.TDLINE.split(/:(.+)/);
                                        let key = (valueSplitted[0] || '').trim();
                                        let val = (valueSplitted[1] || '').trim();
                                        if (!val && key && idx > 0 && processedPoText.length > 0) {
                                            const last = processedPoText[processedPoText.length - 1];
                                            if (!last.val && last.key && !sectionHeadings.includes(key) && !sectionHeadings.includes(last.key)) {
                                                last.key = last.key + ' ' + key;
                                                return;
                                            }
                                        }
                                        processedPoText.push({ key, val });
                                    });
                                    return { ...snap, po_text_sap: { ...snap.po_text_sap, po_text: processedPoText } };
                                }
                                return snap;
                            });
                            return { ...item, snap_shoot_po_texts: snaps };
                        });
                        this.pagination = {
                            current_page: response.data.data.data.current_page,
                            last_page: response.data.data.data.last_page,
                            per_page: response.data.data.data.per_page,
                            total: response.data.data.data.total,
                        }
                        const flags = {};
                        (this.table || []).forEach(item => { flags[item.mcr_item_code] = 1; });
                        this.rowFlags = flags;
                        this.onLoad = false
                    }).onError(error => {
                        this.table = [];
                        this.pagination.total = 0
                        this.onLoad = false;
                    })
                    .call()
            },
            getSnapShoot(row, type) {
                const flag = this.rowFlags[row.mcr_item_code] !== undefined ? this.rowFlags[row.mcr_item_code] : 1;
                const snap = (row.snap_shoot_po_texts || []).find(s => s.flag === flag);
                return snap ? snap[type] : null;
            },
            toggleFlag(rowKey, flag) {
                this.$set(this.rowFlags, rowKey, flag);
            },
            get() {
                this.onLoad = true
                // TODO: Ganti dengan API endpoint yang sesuai untuk mendapatkan detail import data
                Api(this, SapImport.detail_import_data(this.sapImportCode, this.params))
                    .onSuccess(response => {
                       this.table = response.data.data.data.data
                        this.pagination = {
                            current_page: response.data.data.data.current_page,
                            last_page: response.data.data.data.last_page,
                            per_page: response.data.data.data.per_page,
                            total: response.data.data.data.total,
                        }
                        
                        if (this.params.status.toLowerCase() != 'Failed') {
                            this.table = this.table.map(item => {
                                let poTexts = []
                                 if (Array.isArray(item.po_text_sap)) {
                                    poTexts = item.po_text_sap.map(poTextItem => {
                                        let valueSplitted = poTextItem.TDLINE.split(/:(.+)/);
                                        let key = (valueSplitted[0] || '').trim()
                                        let val = (valueSplitted[1] || '').trim()
                                        return { key, val }
                                    })
                                 }
                                return { ... item, po_text_sap: poTexts }
                            })
                        }

                        this.onLoad = false
                    }).onError(error => {
                        this.table = [];
                        this.pagination.total = 0
                        this.onLoad = false;
                    })
                    .call()
            },
            goBack() {
                this.$router.push('/harmonisasi/upload-cataloguing');
            },
            handlePaginate(page) {
                this.params.page = page
                this.get()
            },
            format_date(value){
                if (value) {
                   return moment(String(value)).locale('id').format('DD MMMM YYYY HH:mm')
                }
            },
            handleSelectionChange(selection) {
                this.selectedRows = selection
            },
            checkSelectable(row) {
                return row.status === 'Ready to SAP'
            },
            sendToSAP() {
                Swal.fire({
                    title: 'Apakah anda yakin ?',
                    text: 'Data akan dikirim ke SAP!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Submit',
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#5e72e4',
                    cancelButtonColor: '#f5365c'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.submit()
                    }
                })
            },
            exportFailed() {
                this.loadingBtnExport = true;
                SapImport.export_failed(this.sapImportCode, this.token)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `failed_cataloguing_${this.sapImportCode}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(error => {
                        this.$notify({
                            message: error.response?.data?.message ?? 'Gagal mengunduh file export.',
                            type: 'danger',
                            verticalAlign: 'bottom',
                            horizontalAlign: 'left'
                        });
                    })
                    .finally(() => {
                        this.loadingBtnExport = false;
                    });
            },
            submit() {
                this.loadingBtnSendSAP = true

                const payload = { mcr_codes: this.selectedRows.map(row => row.mcr_code)}

                Api(this, SapImport.send_to_sap(payload))
                .onSuccess((response) => {
                    Swal.fire({
                        title: 'Success',
                        text: this.tt('Data are being processed for SAP upload'),
                        icon: 'success',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#5e72e4',
                        heightAuto: false,
                    })
                })
                .onError((error) => {
                    this.$notify({
                        message: error.response.data.message ?? 'Terjadi kesalahan.',
                        type: 'danger',
                        verticalAlign: 'bottom',
                        horizontalAlign: 'left'
                    })
                })
                .onFinish(() => {
                    this.loadingBtnSendSAP = false
                    this.activeTab = 'Success'
                    this.params.status = 'Success'
                    this.getReleasedData()
                    this.selectedRows = []
                })
                .call()
            }
        }
    };
</script>
<style>
    .btn-darks {
        background-color: #172b4d !important;
        color: white;
    }

    .el-table .cell {
        vertical-align: top !important;
    }

    .el-table td, .el-table th {
        vertical-align: top !important;
    }

    .swal2-checkbox label, .swal2-radio label {
        margin-bottom: -24px!important;
        font-size: 14px;
        display: block;
    }
    .swal2-validation-message {
        margin-top: 40px!important;
    }
</style>
